import { notification } from 'antd';
import i18n from 'i18n';

export const SUCCESS_NOTIFICATION_ID = 'SUCCESS_NOTIFICATION_ID';

export const notificationService = (status: { success?: boolean; error?: boolean; info?: boolean }, mes: string) => {
	const { language } = i18n;
	const args = {
		message: <div>{mes}</div>,
		description: language.includes('en') ? 'Thank You =)' : 'Gracias =)'
	};
	const errorArgs = {
		message: mes,
		description: language.includes('en') ? 'I am sorry =(' : 'Lo siento =('
	};

	const infoArgs = {
		message: mes,
		description: ''
	};
	if (status.success) {
		setTimeout(() => notification.success(args), 0);
	} else if (status.error) {
		setTimeout(() => notification.error(errorArgs), 0);
	} else if (status.info) {
		setTimeout(() => notification.info(infoArgs), 0);
	}
};
